<script lang="ts">
	import { Dialog as DialogPrimitive } from "bits-ui";
	import ModalRoot from "../modal/modal-root.svelte";

	let { open = $bindable(false), ...restProps }: DialogPrimitive.RootProps & { modalPriority?: number } = $props();
</script>

<ModalRoot bind:open {...restProps} />
